/* eslint-disable react/no-unused-state */
import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
import { format, parse } from 'date-fns'
// import moment from 'moment'
import Table from 'components/Table'
import Heading from 'components/Heading'
import Card from 'components/Card'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./BeneficiaryList.scss'),
  { columns: require('../../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

const headerStyles = classnames(styles.table.unSortable)

class BeneficiaryUploadList extends Component {
  static propTypes = {
    beneficiaryUploadItems: PropTypes.instanceOf(Array),
    header: PropTypes.string,
  }
  static defaultProps = {
    beneficiaryUploadItems: {},
    header: '',
  }

  _statusColor = (status) => {
    switch (status) {
      case constants.BENEFICIARY.UPLOAD_STATUS.PENDING:
        return styles.columns.description
      case constants.BENEFICIARY.UPLOAD_STATUS.COMPLETED:
        return styles.statusSuccess
      case constants.BENEFICIARY.UPLOAD_STATUS.ERROR:
        return styles.statusError
      case constants.BENEFICIARY.UPLOAD_STATUS.COMPLETEDWITHERRORS:
      case constants.BENEFICIARY.UPLOAD_STATUS.COMPLETEDWITHWARNINGS:
        return styles.statusWarnings
      default:
        return styles.columns.description
    }
  }  

  renderCols = () => {
    return (
      <tr>
        <th className={(styles.columns.description, headerStyles)}>
          Name
        </th>
        <th className={(styles.columns.status, headerStyles)}>Status</th>
        <th className={(styles.columns.created, headerStyles)}>Modified</th>
        <th className={(styles.columns.view, headerStyles)} />
      </tr>
    )
  }

  renderData = () => {
    return this.props.beneficiaryUploadItems.length ? (
      this.props.beneficiaryUploadItems.map(upload => (
        <tr className={styles.base} key={upload.itemId}>
          <td className={styles.columns.description}>
            <a href={upload.path} rel="noopener noreferrer" target="_blank" title={upload.documentName}>{upload.documentName}</a>
          </td>
          <td className={this._statusColor(upload.status)}>{upload.status}</td>
          <td>{(upload.modified ? format(parse(upload.modified, constants.DATE_FORMAT.SPO_FORMAT, new Date()), constants.DATE_FORMAT.STANDARD_AU_FULLMONTH_TIME) : '')}</td>
          <td>
            {(upload.status === constants.BENEFICIARY.UPLOAD_STATUS.COMPLETED
            || String(upload.status) === constants.BENEFICIARY.UPLOAD_STATUS.ERROR
            || String(upload.status) === constants.BENEFICIARY.UPLOAD_STATUS.COMPLETEDWITHERRORS
            || String(upload.status) === constants.BENEFICIARY.UPLOAD_STATUS.COMPLETEDWITHWARNINGS) &&
            <a href={upload.logPath} rel="noopener noreferrer" target="_blank">UPLOAD REPORT</a>}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan={5}>
          <div className={styles.noPartnerPlans}>
            <div>No matching records found</div>
          </div>
        </td>
      </tr>
    )
  }

  render() {
    return (
      <div>
        <Heading noTopPadding>{this.props.header}</Heading>
        <Card noPadding>
          <Table>
            <thead>{this.renderCols()}</thead>
            <tbody>{this.renderData()}</tbody>
          </Table>
        </Card>
      </div>
    )
  }
}

export default BeneficiaryUploadList



// WEBPACK FOOTER //
// ./src/views/Beneficiaries/components/Beneficiary/BeneficiaryUploadList.js